import React from "react";
import { Navbar as BootstrapNavbar, Nav, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useNavigate } from "react-router-dom";
import { getUserRole, getUserEmail, getDefaultRoute } from "../../utils/permissions";

const NavBar = () => {
  const navigate = useNavigate();
  const userEmail = getUserEmail();
  const userRole = getUserRole(userEmail);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userEmail");
    navigate("/login");
  };

  return (
    <BootstrapNavbar bg="dark" variant="dark" expand="lg" className="px-5 navbar-grand">
      <LinkContainer to={getDefaultRoute(userEmail)}>
        <BootstrapNavbar.Brand>Grand Kafa RS CMS</BootstrapNavbar.Brand>
      </LinkContainer>
      <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
      <BootstrapNavbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          {userRole === 'admin' && (
            <>
              <NavDropdown title="Banner" id="banner-dropdown">
                <LinkContainer to={"/banner/view"}>
                  <NavDropdown.Item>Pregled</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to={"/banner/create"}>
                  <NavDropdown.Item>Kreiraj</NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>

              <NavDropdown title="Activity" id="activity-dropdown">
                <LinkContainer to={"/activity/view"}>
                  <NavDropdown.Item>Pregled</NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to={"/activity/create"}>
                  <NavDropdown.Item>Kreiraj</NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>

              <LinkContainer to={"/hero-banner-text"}>
                <Nav.Link>Hero banner tekst</Nav.Link>
              </LinkContainer>

              {/* <NavDropdown title="Game" id="game-dropdown">
                <LinkContainer to={"/game/players"}>
                  <NavDropdown.Item>Pregled igrača</NavDropdown.Item>
                </LinkContainer>
              </NavDropdown> */}
            </>
          )}

          {(userRole === 'admin' || userRole === 'promotion') && (
            <NavDropdown title="NI 2026" id="promotion-dropdown">
              <LinkContainer to={"/promotion/entries"}>
                <NavDropdown.Item>NI prijave</NavDropdown.Item>
              </LinkContainer>
              <LinkContainer to={"/promotion/winners"}>
                <NavDropdown.Item>NI dobitnici</NavDropdown.Item>
              </LinkContainer>
            </NavDropdown>
          )}

          {(userRole === 'admin' || userRole === 'grand') && (
            <LinkContainer to={"/quiz/view"}>
              <Nav.Link>Grand Quiz</Nav.Link>
            </LinkContainer>
          )}
        </Nav>
        <Nav className="ms-auto">
          <Nav.Link onClick={logout}>Logout</Nav.Link>
        </Nav>
      </BootstrapNavbar.Collapse>
    </BootstrapNavbar>
  );
};

export default NavBar;